<template>
	<div>a{{ss}}</div>
</template>

<script>
	export default {
		props: {
			ss: String
		}
	}
</script>
<style>
</style>
